import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '1. ¿Cualquiera puede hacer estos rituales?',
    a: 'Sí, absolutamente. No necesitás ser "espiritual", ni saber de energías, ni tener experiencia previa. El sistema está diseñado para que CUALQUIER mujer (sin importar sus creencias) pueda usar estos rituales de forma simple y segura.'
  }, {
    q: '2. ¿Necesito ingredientes raros o caros?',
    a: 'No. El 90% de los ingredientes los conseguís en cualquier verdulería, almacén o herboristería de tu barrio. Además, incluimos la Lista Maestra de Ingredientes con equivalencias argentinas para que nunca te quedes trabada buscando algo. Inversión promedio en ingredientes: $5.000-$8.000 para 3 meses de rituales.'
  }, {
    q: '3. ¿Cuánto tiempo toma preparar un ritual?',
    a: 'Entre 5 y 15 minutos, dependiendo del ritual que elijas. Ritual Express: 5 minutos. Ritual Completo: 15 minutos. Ritual Ceremonial: 30 minutos. Vos elegís según tu tiempo disponible.'
  }, {
    q: '4. ¿Realmente funciona o es placebo?',
    a: 'Funciona. Los baños de pies con sales y hierbas son prácticas usadas hace SIGLOS en todas las culturas. ¿Por qué? Porque el agua tibia relaja el sistema nervioso (científicamente comprobado), las sales ayudan a desinflamar y liberar tensión muscular, las hierbas tienen propiedades aromáticas que actúan sobre el cerebro, y el RITUAL en sí te obliga a PARAR, desconectar y cuidarte. ¿Es magia? No. ¿Funciona? Absolutamente.'
  }, {
    q: '5. ¿Cómo recibo el material?',
    a: 'Inmediatamente por email después de la compra. 1. Hacés el pago por Mercado Pago. 2. En 2-5 minutos recibís un email con links de descarga de todos los PDFs, audio de meditación en MP3 y acceso a todas las plantillas. Todo digital. Nada físico. Descarga instantánea.'
  }, {
    q: '6. ¿Es seguro comprar acá?',
    a: 'Totalmente. El pago se procesa a través de Mercado Pago, la plataforma más segura de Argentina. Tus datos están encriptados y protegidos. Podés pagar con tarjeta de crédito, débito o en efectivo. Recibís comprobante oficial.'
  }, {
    q: '7. ¿Esto reemplaza la terapia o la medicación?',
    a: 'No. Este sistema NO reemplaza tratamientos médicos o psicológicos. Si estás en terapia o tomando medicación, seguí con eso. Los rituales son un COMPLEMENTO para manejar el estrés del día a día, mejorar tu energía y tener una herramienta de autocuidado. Muchas mujeres los usan JUNTO con terapia y obtienen mejores resultados. Siempre consultá con tu profesional de salud.'
  }];
  return <section ref={ref} className="py-20 sm:py-32 bg-white" data-id="element-70">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-72">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2F4538] mb-6" data-id="element-73">
            ❓ Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="border border-[#D4AF37]/30 rounded-2xl overflow-hidden bg-white hover:border-[#B4A7D6]/50 transition-colors" data-id="element-75">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-76">
                <span className="font-bold text-[#2F4538] pr-8" data-id="element-77">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#B4A7D6] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-78" />
              </button>
              <AnimatePresence data-id="element-79">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-80">
                    <div className="px-6 pb-5 text-[#1a1a1a]/80 leading-relaxed" data-id="element-81">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}